import request from '@/router/axios'

async function getVodSign(params) {
  return request({
    url: '/basic/tencent-cloud/vod/sign',
    method: 'GET',
    params,
  });
}

async function getCosSign() {
  return request({
    url: '/basic/tencent-cloud/cos/sign',
    method: 'GET',
  });
}

async function getCourseVodSign(params) {
  return request({
    url: '/basic/tencent-cloud/course/vod/sign',
    method: 'GET',
    params,
  });
}

export default {
  getVodSign,
  getCosSign,
  getCourseVodSign
}
